import React from "react";
import { FlatList, FlatListProps } from "react-native";
import BottomBarPadding from "@components/BottomBarPadding";
import LBox from "@components/LBox";
import { DragContext } from "@utils/DragContext";
import { useDragScroll } from "@hooks/useDragScroll";

interface LFlatListProps<T> extends FlatListProps<T> {
  disableAutomaticPadding?: boolean;
}

declare module "react" {
  function forwardRef<T, P = object>(
    render: (props: P, ref: React.Ref<T>) => React.ReactElement | null,
  ): (props: P & React.RefAttributes<T>) => React.ReactElement | null;
}

const LFlatList = <T,>(
  { disableAutomaticPadding, ListFooterComponent, ...rest }: LFlatListProps<T>,
  ref: React.ForwardedRef<FlatList>,
) => {
  const { isDragging, hasDragged, webProps } = useDragScroll();
  return (
    <DragContext.Provider value={{ isDragging, hasDragged }}>
      <FlatList
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
        keyboardDismissMode="on-drag"
        keyboardShouldPersistTaps="handled"
        {...webProps}
        {...rest}
        ref={ref}
        ListFooterComponent={() => (
          <LBox>
            <>
              {ListFooterComponent}
              {!disableAutomaticPadding && <BottomBarPadding />}
            </>
          </LBox>
        )}
      />
    </DragContext.Provider>
  );
};

export default React.forwardRef(LFlatList);
